import { Cookies } from "react-cookie";

const MAX_COOKIE_LIFE =
  window && window.OPSEEKER_CONFIG && window.OPSEEKER_CONFIG.COOKIE_LIFE
    ? window.OPSEEKER_CONFIG.COOKIE_LIFE
    : 10000000;

export const saveCookie = (name, value) => {
  let cookies = new Cookies();
  cookies.set(name, value, {
    path: "/",
    maxAge: MAX_COOKIE_LIFE,
    secure: !isLocalHost,
    sameSite: isLocalHost ? "lax" : "none",
  });
};

export const getCookieValue = (name, parser) => {
  let cookies = new Cookies();
  let value = cookies.get(name);
  return parser && value ? parser(value) : value;
};

export const removeCookie = (name) => {
  let cookies = new Cookies();
  cookies.remove(name);
};

export const cookieConsentGiven = getCookieValue("COOKIE_CONSENT") === "true";
export const googleAnalyticsDisabled = getCookieValue("DISABLE_GA") === "true";

export const giveCookieConsent = () => {
  saveCookie("COOKIE_CONSENT", true);
};

export const configureAnalyticsCookies = (analyticsEnabled) => {
  saveCookie("DISABLE_GA", !analyticsEnabled);
  window.location.reload();
};

const isLocalHost = window.location.origin.includes("localhost:");
